/* eslint-disable no-unused-vars */
import React, { Component, Suspense, lazy } from 'react';
import { getUserInformation } from '../src/Utils/UserInfo';
// import Loader from "../src/components/common/Loader";
import FormLoader from "../src/components/shared/FormLoader/FormLoader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getEnv, config } from '../src/Utils/environment';
import { initTracking } from '../src/Utils/tracking';
import { AuthProvider } from '../src/contexts/AuthContext';
const WithoutAuthenticate = lazy(() => import('../src/Views'));
const Authenticated = lazy(() => import('../src/Views/AuthRouting'));
const ErrorBoundary = lazy(() => import('../src/components/common/ErrorBoundary'));

class App extends Component{
    constructor(props){
        super(props);
        this.state = {
            user: {}
        };
    };

    componentDidMount(){
        initTracking();
        let data = getUserInformation();
        this.setState({ user: data });
    };

    renderWithoutAuthentication(){ return <WithoutAuthenticate />; };

    renderAuthentication(){ return <Authenticated />; };

    // renderSpinner(){ return <Loader />; };

    renderApp(){

        if(config.ENV === 'staging'){
            console.log('Staging environment');
        }else if(config.ENV === 'uat'){
            console.log('UAT environment');
        }else if(config.ENV === 'production'){
            console.log('Production environment');
        }else{
            console.log('Development environment');
        }

        const { user } = this.state;
        if(!user?.token){
            return this.renderWithoutAuthentication();
        }
        return this.renderAuthentication();
    };

    render(){
        return (
            <div>
                <ErrorBoundary>
                <AuthProvider>
                    {/* <ToastContainer toastStyle={{ backgroundColor: "crimson" }}/> */}
                    <Suspense fallback={<FormLoader />}>{this.renderApp()}</Suspense>
                    <ToastContainer />
                </AuthProvider>
                </ErrorBoundary>
            </div>
        );
    };
};
export default App;